import { portalApi } from "./client";

// Admin User Impersonation — the PORTAL half of the exit path.
//
// Separate from the staff `src/api/impersonation.ts` on purpose, and not a
// duplicate of it: the two sessions ride two independent cookies, so ending a
// portal impersonation has to go through the portal HTTP client. Portal
// isolation (`portal/isolation.test.ts`) also forbids this bundle importing
// anything under `@/api/*`, which makes the split structural rather than
// stylistic.
//
// There is no `start` here by design — impersonation is always INITIATED from
// a staff surface by a permission-gated admin; the portal can only end it.

export const portalImpersonationApi = {
  /** Ends the impersonated PORTAL session (portal cookie). */
  exit: () => portalApi.post<void>("/impersonation/exit"),
};
